<template>
  <div class="trial animate__animated animate__fadeIn">
    <p class="title">{{ title }}</p>
    <div class="content">
      <el-form :model="form" :rules="rules" ref="form" label-width="auto" class="part left">
        <el-form-item prop="username" label="姓名" class="form-item">
          <el-input type="text" v-model.trim="form.username" autocomplete="off" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号" class="form-item">
          <el-input type="text" v-model.trim="form.phone" autocomplete="off" placeholder="请输入您的手机号"
            maxlength="11"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码" class="form-item">
          <el-input type="text" v-model.trim="form.password" autocomplete="new-password" placeholder="请输入密码"
            show-password></el-input>
          <span v-if="showPasswordTip" class="password-tip">必须数字+字母（不区分大小写） +特殊字符</span>
        </el-form-item>
        <el-form-item prop="captchaCode" label="图形验证码" class="form-item code">
          <el-input type="text" v-model.trim="form.captchaCode" autocomplete="off" placeholder="请输入图形验证码"
            maxlength="4"  @input="handleInput"></el-input>
          <img :src="captchaSrc" class="captcha cursor-pointer" @click="getCaptcha" />
        </el-form-item>
        <el-form-item prop="verificationCode" label="验证码" class="form-item code">
          <el-input type="text" v-model.trim="form.verificationCode" autocomplete="off" maxlength="6" placeholder="请输入手机验证码"></el-input>
          <el-button type="text" :disabled="!isTrue || form.phone.length !== 11 || hasSend || form.captchaCode.length !== 4" :class="['get-code', { 'btn-disabled': !isTrue || form.phone.length !== 11 || hasSend }]" @click.prevent="getCode">
            {{ sendBtnText }}
          </el-button>
        </el-form-item>
      </el-form>
      <p class="submit-btn" @click="submitForm('form')">提交</p>
      <p id="tel">或致电 010-8210-1180</p>
    </div>
  </div>
</template>
<script>
import * as api from "@/api";
export default {
  name: "TrialZaxis",
  props: {
    title: {
      type: String,
      default: '注册'
    },
  },
  created() {
    this.redirect = this.getJumpUrl()
  },
  data() {
    // const CheckCaptchaCode = async (rule, value, callback) => {
    //   if (value) {
    //     await api
    //       .checkCaptcha({ captcha: this.form.captchaCode })
    //       .then(({ success }) => {
    //         if (success) {
    //           callback();
    //           this.isTrue = true; //图形验证码正确
    //         } else {
    //           callback(new Error("验证码错误"));
    //           this.getCaptcha();
    //         }
    //       });
    //   }
    // };
    const CheckPassword = async (rule, value, callback) => {
      this.showPasswordTip = false;
      if (value === '') {
        callback(new Error("请输入密码"));
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error("密码长度为6~20"));
      } else {
        const regex =
          /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*()\-=_+`~,.?])[A-Za-z0-9!@#$%^&*()\-=_+`~,.?]{6,20}$/;
        if (regex.test(value)) {
          this.showPasswordTip = true;
          callback();
        } else {
          callback(new Error("必须数字+字母（不区分大小写）+特殊字符组合"));
        }
      }
    };
    const CheckPhone = async (rule, value, callback) => {
      if (value) {
        if (
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
            value
          )
        ) {
          callback();
        } else {
          callback(new Error("手机号格式错误"));
        }
      }
    };
    return {
      form: {
        username: "",
        phone: "",
        password: "",
        verificationCode: "",
        captchaCode: "",
      },
      redirect: '', // 登录后的重定向地址
      hasSend: false, //是否已经发送验证码
      showPasswordTip: true, //是否显示密码提示
      countDown: 60, //倒计时
      captchaSrc: "",
      // visible: false,
      // submitSuccess: false,
      // visibleCapcha: true //是否显示图形验证码
      isTrue: false, //图形验证码是否错误,一开始为错误
      rules: {
        username: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          { validator: CheckPhone, trigger: "blur" },
        ],
        password: [
          { validator: CheckPassword, trigger: "blur" },
          { required: true, trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        captchaCode: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
          // { validator: CheckCaptchaCode, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getCaptcha();
  },
  computed: {
    sendBtnText() {
      return this.hasSend ? `${this.countDown}s` : "获取验证码";
    },
  },
  methods: {
    getJumpUrl() {
      // 获取重定向地址
      let params = this.$route.query
      let url = params?.redirect ? params.redirect : ''
      Object.keys(params)?.forEach((key) => {
        if (key !== 'redirect') {
          url = `${url}${url.includes('?') ? '&' : '?'}${key}=${params[key]}`
        }
      })
      return url
    },
    // 倒计时
    countDownTimer(){
      this.hasSend = true;
      const timer1 = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          this.hasSend = false;
          this.countDown = 60;
          clearInterval(timer1);
        }
      }, 1000);
    },
    getCode() {
      const params = {
        mobile: this.form.phone,
        captcha: this.form.captchaCode,
        temId: 5
      }
      if (this.redirect) {
        // 避免 new URL() 报错
        params.source = new URL(this.redirect)?.hostname || '' // 渠道来源
      }
      api
        .verificationCodeSend(params)
        .then(({ data }) => {
          const { code } = data
          if (code === '0000') {
            this.$message.success('验证码已发送')
            this.$refs['form'].clearValidate('captchaCode')
            this.isTrue = true
            this.countDownTimer()
          } else {
            this.$refs['form'].fields[3].validateMessage = '图形验证码错误'
            this.$refs['form'].fields[3].validateState = 'error'
            this.getCaptcha()
            this.isTrue = false
          }
        });
    },
    async getCaptcha() {
      const { data } = await api.getCaptcha();
      const url = window.URL.createObjectURL(
        new Blob([data], { type: "image/jepg" })
      );
      this.captchaSrc = url;
    },
    async handleInput(value) {
      //当图形验证码和手机号填写完毕时自动发送验证码
      if (value.length === 4) {
        this.isTrue = true
        // const { success } = await api.checkCaptcha({ captcha: this.form.captchaCode })
        // if (success) {
        //   this.$refs['form'].clearValidate('captchaCode')
        //   this.isTrue = true
        // } else {
        //   if (!this.isTrue) {
        //     this.$refs['form'].fields[3].validateMessage = '验证码错误'
        //     this.$refs['form'].fields[3].validateState = 'error'
        //     this.getCaptcha()
        //   }
        // }
      } else {
        this.isTrue = false
      }
    },
    autoJumpLogin() {
      setTimeout(() => {
        this.$router.push(`/login-zaxis?redirect=${this.redirect}`)
      }, 1500)
    },
    async submitForm(formName) {
      let validateFieldList = [];
      this.$refs[formName].validateField(
        ["username", "phone", "verificationCode", "password"],
        (valid) => {
          if (!valid) {
            //校验通过走这里,每通过一次,会往这个数组里加一个""
            validateFieldList.push(valid);
            if (
              validateFieldList.length == 4 &&
              validateFieldList.every((item) => item === "" && this.isTrue)
            ) {
              //这里写校验通过的业务逻辑
              api.registerByPhoneZaxis({ ...this.form, confirmPassword: this.form.password, privacyAgreementStatus: 1 }).then(({ success }) => {
                if (success) {
                  // this.submitSuccess = true;
                  // this.visible = true;
                  // this.getCaptcha();
                  // this.$refs[formName].resetFields()//重置表单数据
                  // this.isTrue = false;
                  this.$message.success('注册成功')
                  this.autoJumpLogin()
                }
              });
            }
          }
        }
      );
    },
  },
};
</script>
<style lang='scss' scoped>
.dialog-content {
  font-size: Translate(20px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .contact {
    width: 800px;
    padding: Translate(24px) 0 Translate(66px) 0;
    font-size: Translate(16px);
    color: #333333;
    text-align: center;
    line-height: 24px;
    font-weight: 400;
  }
}

.trial {
  background: #f5f6f9;
  padding-top: Translate(74px);

  .title {
    font-size: Translate(32px);
    color: #333;
    font-weight: 500;
  }

  // width: $container-width;
  position: relative;
  margin: 0 auto;
  // background-color: #fff;
  // padding: 150px 120px;
  box-sizing: border-box;

  .content {
    padding: Translate(34px) Translate(92px) Translate(66px);
    // width: Translate(652px);
    // height: Translate(720px);
    // margin: 0 auto;

    .submit-btn {
      margin-top: Translate(14px);
      margin-bottom: Translate(20px);
      display: inline-block;
      text-align: center;
      width: Translate(280px);
      height: Translate(48px);
      background-color: #0058FF;
      color: #fff;
      border-radius: Translate(24px);
      line-height: Translate(48px);
      cursor: pointer;

      &:hover {
        background-color: #337ee5;
      }
    }

    .part {
      .code {
        position: relative;

        .captcha {
          width: Translate(80px);
          position: absolute;
          right: 10px;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .error {
          position: absolute;
          color: #f56c6c;
          bottom: -35px;
          font-size: Translate(12px);
          line-height: Translate(20px) px;
          font-weight: 400;
        }
      }
    }

    form {

      // border-right: 1px solid #E8E8E8;
      .form-item {
        // display: flex;
        margin-bottom: Translate(26px);
      }
    }
  }
}

#tel {
  font-size: Translate(14px);
  color: #333333;
  text-align: center;
  font-weight: 400;
}

.get-code {
  position: absolute;
  font-size: Translate(14px);
  color: #0058FF;
  font-weight: 400;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  border: none;
  background: #fff;
}

.btn-disabled {
  color: #bbb;
}

.password-tip {
  position: absolute;
  left: 0;
  bottom: Translate(-18px);
  font-size: Translate(12px);
  color: #bbb;
  line-height: Translate(14px);
  font-weight: 400;
}

.el-input {
  width: 380px;
}

::v-deep .form-item .el-input__inner {
  height: 48px;
  border: 1px solid #e3e6e9;
}

::v-deep .dialog-content .el-icon-success {
  &::before {
    vertical-align: -4px;
  }
}

.dialog-footer {
  .confirm {
    background: #0058FF;

    &:hover {
      background: #337ee5;
    }
  }
}
</style>

<style lang="scss">
// .submit-success{
//   .el-dialog{
//     .el-dialog__header{
//       padding-top: 46px;
//       background: #FAFAFA;
//     }
//   }
//   .el-dialog__body {
//       padding-top: 50px;
//       padding-bottom: 0;
//     }
// }
</style>
